module.exports = __webpack_public_path__ + "static/toggl-track-pricing-plans-ac7bd732a83c3a5d95932786125d7042.jpg";